import '../styles/hyperlink-popover.css';
var t = "_positionedPopover_12beq_1",
    e = "_popoverContent_12beq_5",
    o = "_readState_12beq_17",
    n = "_clickableLink_12beq_23",
    a = "_important_12beq_23",
    r = "_writeState_12beq_35",
    i = "_gappedContent_12beq_41",
    _ = "_separator_12beq_46",
    p = "_editableLink_12beq_52",
    s = "_editableLinkWithError_12beq_56",
    b = "_readStateButtons_12beq_62",
    c = {
  positionedPopover: t,
  popoverContent: e,
  readState: o,
  clickableLink: n,
  important: a,
  writeState: r,
  gappedContent: i,
  separator: _,
  editableLink: p,
  editableLinkWithError: s,
  readStateButtons: b
};
export { c as s };